import BackgroundMixin from './BackgroundMixin'
import DefsLayerMixin from './DefsLayerMixin'
import HelperLayerMixin from './HelperLayerMixin'
import LineLayerMixin from './LineLayerMixin'
import ShapeLayerMixin from './ShapeLayerMixin'
import SnappableMixin from './SnappableMixin'

import LineHotAreaLayerMixin from './LineHotAreaLayerMixin'

import ToolLayerMixin from './ToolLayerMixin'

import EventSource from '../EventSource/index'

import ExtentAutoChangableMixin from './ExtentAutoChangableMixin'

let Mixins = {
  BackgroundMixin,
  DefsLayerMixin,
  ToolLayerMixin,
  LineHotAreaLayerMixin,
  LineLayerMixin,
  ShapeLayerMixin,
  HelperLayerMixin,
  SnappableMixin,
  ExtentAutoChangableMixin
}

let queue = [
  "BackgroundMixin",
  "DefsLayerMixin",
  "ToolLayerMixin",
  "LineHotAreaLayerMixin",
  "LineLayerMixin",
  "ShapeLayerMixin",
  "HelperLayerMixin",
  "SnappableMixin",
  "ExtentAutoChangableMixin"
]

export default class extends queue.reduceRight((p, c, i, a) => {
  return Mixins[c](p)
}, EventSource) {}


// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/Layers/index.js